import { render, staticRenderFns } from "./MovementIn.vue?vue&type=template&id=02d38f3a"
import script from "./MovementIn.vue?vue&type=script&lang=js"
export * from "./MovementIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports